<template>
  <div style="min-width: 90%">
    <h1 class="grey--text text--darken-2">Рассылки</h1>

    <div class="mt-3 mb-3">
      <v-btn small color="blue" dark @click="createAction()">
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Создать
      </v-btn>
      <v-btn small color="yellow" @click="refreshAction" class="ml-3">
        <v-icon left dark>mdi-refresh</v-icon> Обновить
      </v-btn>
      <v-btn small color="#61a038" dark @click="planfixAction" :loading="loadingPlanfix" class="ml-3">
        <v-icon left>mdi-send-outline</v-icon> Отправить в PlanFix
      </v-btn>
    </div>

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск"
      single-line
      hide-details
      class="mb-3">
    </v-text-field>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      item-key="mailing_id"
      no-data-text="Рассылки отсутствуют"
      show-select
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, -1],
        showFirstLastPage: true,
      }"
      dense
      class="elevation-1">
      <template v-slot:item.mailing_name="{ item }">
        <span @click="editAction(item)" class="editable" style="cursor: pointer">{{ item.mailing_name }}</span>
      </template>
      <template v-slot:item.mailing_date="{ item }">
        {{ item.mailing_date == null ? '—' : item.mailing_date }}
      </template>
      <template v-slot:item.mailing_time="{ item }">
        {{ item.mailing_time == null ? '—' : item.mailing_time.substr(0,5) }}
      </template>
      <template v-slot:item.mailing_status="{ item }">
        <select class="caption" @change="statusAction($event, item)">
          <option v-for="s in mailingStatuses" :key="s.value" :value="s.value" v-html="s.text" :disabled="isDisabled(item, s.value)" :selected="s.value==item.mailing_status" :style="'color: '+s.color"/>
        </select>
      </template>
      <template #item.mailing_planfix_task="{ item }">
        <span v-if="item.mailing_planfix_task" style="color: #61a038; cursor: pointer" @click="goPlanfixAction(item.mailing_planfix_task)">{{ item.mailing_planfix_task }}</span>
        <span v-else class="grey--text text--lighten-1">&mdash;</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import api from '@/api'
  import { mailingStatuses } from '@/common.js'

  export default {
    data: () => ({
      loading: false,
      loadingPlanfix: false,
      headers: [
        { text: 'Наименование', value: 'mailing_name' },
        { text: 'Дата', value: 'mailing_date', align: 'center', width: 120 },
        { text: 'Время', value: 'mailing_time', align: 'center', sortable: false, width: 100 },
        { text: 'Статус', value: 'mailing_status', align: 'left', width: 120 },
        { text: 'Planfix', value: 'mailing_planfix_task', align: 'center', width: '100', sortable: false },
        { text: 'Юнитов', value: 'qnt', align: 'right', width: 60, sortable: false },
      ],
      items: [],
      search: '',
      mailingStatuses
    }),
    mounted () {
      this.load()
    },
    methods: {
      load () {
        this.loading = true;
        api.get('mailings/list').then(response => {
          this.loading = false;
          if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          this.items = response.data.data.mailings
        }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
      },
      isDisabled (item, status) {
        if ( status == 'planned' && !item.mailing_date ) return true
        if ( status == 'sent' && !item.mailing_date ) return true
        return false
      },
      createAction () {
        this.$router.push('/mailings/new')
      },
      editAction (item) {
        this.$router.push('/mailings/'+item.mailing_id)
      },
      goPlanfixAction (planfixTask) {
        window.open('https://apteka911.planfix.ua/task/'+planfixTask)
      },
      planfixAction () {
        this.loadingPlanfix = true
        api.post('mailings/planfix').then(response => {
          this.loadingPlanfix = false
          if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          if ( response.data.data.affected > 0 )
          {
            this.$root.$alert('Актуализировано рассылок: '+response.data.data.affected)
            this.load()
          }
          else
            this.$root.$alert('Нет новой информации для добавления в PlanFix')
        }).catch(error => (this.loadingPlanfix = false, this.$root.$alert(error, true)) )
      },
      statusAction (event, item) {
        if ( event.target.value == item.mailing_status ) return
        api.post('mailings/update/'+item.mailing_id, {mailing_status: event.target.value}).then(response => {
          if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          item.mailing_status = response.data.data.mailing.mailing_status
          this.$root.$alert("Статус изменен")
        }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
      },
      refreshAction () {
        this.load()
      }
    }
  }
</script>

<style scoped>
.editable:hover { color: #08A2B8; border-bottom: 1px #08A2B8 dashed; }
</style>
